import { useEffect, useState } from "react";
import WMTSCapabilities from "ol/format/WMTSCapabilities";
/**
 * Perform the GetCapabilities request of a WMTS service.
 *
 * @param uri WMTS service url, without GetCapabilities specific parameters.
 * @param version WMTS service version.
 * @returns The capabilities, loading state and error state
 */
export default function useWmtsCapabilities(uri, version = "1.0.0") {
    const [capabilities, setCapabilities] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    useEffect(() => {
        if (!uri)
            return;
        setLoading(true);
        let url = uri;
        if (url.indexOf("?") === -1)
            url += "?";
        const controller = new AbortController();
        const signal = controller.signal;
        fetch(url + `&SERVICE=WMTS&REQUEST=GetCapabilities&VERSION=${version}`, {
            signal,
        })
            .then((res) => res.text())
            .then((res) => {
            const wmts = new WMTSCapabilities();
            const wmtsCap = wmts.read(res);
            setCapabilities(wmtsCap);
            setLoading(false);
        })
            .catch((err) => {
            if (err.name === "AbortError")
                return;
            console.error(err);
            setError(true);
            setLoading(false);
        });
        return () => controller.abort();
    }, [uri, version]);
    return { capabilities, loading, error };
}
